import { useInfiniteQuery } from '@tanstack/react-query';

import type { GetAdminV1OrgSchedulesIdRuns200 } from '@nucleus-commerce/api-client/admin';

import { schedulesApi } from '../api/schedules-api';

import { scheduleKeys } from './schedule-keys';

const PAGE = 20;
const POLL_MS = 5_000;

const unfinished = (pages: readonly GetAdminV1OrgSchedulesIdRuns200[] | undefined) =>
  pages?.[0]?.items.some((run) => run.status === 'queued' || run.status === 'running') ?? false;

/**
 * Runs newest first, a page at a time. Polls while the schedule holds a run or the newest page
 * still shows one queued or running (run now answers before the worker claims it). The final
 * refetch when a run finishes comes from `useSchedule` invalidating the runs.
 */
export function useScheduleRuns(id: string, running: boolean) {
  return useInfiniteQuery({
    queryKey: scheduleKeys.runList(id, { limit: PAGE }),
    queryFn: ({ pageParam }) =>
      schedulesApi.runs(id, { limit: PAGE, ...(pageParam ? { cursor: pageParam } : {}) }),
    initialPageParam: null as string | null,
    getNextPageParam: (page) => page.nextCursor,
    refetchInterval: (query) => (running || unfinished(query.state.data?.pages) ? POLL_MS : false),
  });
}
